// Perfect Running code

// import React, { useContext, useRef, useEffect, useState } from "react";
import React, { useContext, useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
// import { useNavigationType } from "react-router-dom";
// import stocai from "../../../assets/Stocai.png";
import storyImg from "../../../assets/DashIllustration.png";
import { UserContext } from "../../../UserContext";
import star from "../../../assets/stars.png";
import boxes from "../../../assets/Boxes.png";
// import emptyBoxes from "../../../assets/EmptyBoxes.png";
import emoji1 from "../../../assets/Emoji1.png";
import emoji2 from "../../../assets/Emoji2.png";
import { motion, AnimatePresence } from "framer-motion";
// import { useParams, useLocation } from "react-router-dom";
import { useLocation } from "react-router-dom";
// import { PencilLine, ChevronRight, NotebookPen } from "lucide-react";
import { PencilLine, NotebookPen } from "lucide-react";
import DumpBooth from "./DumpBooth";
import TitleSelectionPopup from "./TitleSelectionPopup";
// import { TiPlus, TiMinus } from "react-icons/ti";
import { FaCirclePlus } from "react-icons/fa6";
import {
  FaChevronCircleLeft,
  FaChevronCircleRight,
  FaChevronCircleDown,
} from "react-icons/fa";
import { FiArrowRight } from "react-icons/fi";

// const spring = {
//   type: "spring",
//   stiffness: 200,
//   damping: 30,
//   duration: 1.5,
// };

const Dashboard = ({ onSelectStory }) => {
  const [userStorys, setUserStorys] = useState([]);
  const [sessionStats, setSessionStats] = useState(null);
  const [selectedStory, setSelectedStory] = useState(null);
  const [storyChapters, setStoryChapters] = useState(null);
  const [storyIdentity, setStoryIdentity] = useState("");
  const [showTitlePopup, setShowTitlePopup] = useState(false);

  // NEW STATE FOR BARRIERS AND STAKES
  const [stakeData, setStakeData] = useState({
    Recoverable: [],
    Critical: [],
  });
  const [stakeTab, setStakeTab] = useState("Recoverable");
  const [barrierTab, setBarrierTab] = useState("Internal");
  // const [allBarriers, setAllBarriers] = useState({
  const [, setAllBarriers] = useState({
    internal: [],
    external: [],
  });
  const [recentBarriers, setRecentBarriers] = useState({
    internal: [],
    external: [],
  });
  const [activeBarrierIdx, setActiveBarrierIdx] = useState(null);
  const [activeStakeIdx, setActiveStakeIdx] = useState(null);

  // NEW STATE FOR "LET'S ADDRESS" FUNCTIONALITY
  const [selectedForStartReflection, setSelectedForStartReflection] =
    useState(null);

  const [needsResetBeforeNewStory, setNeedsResetBeforeNewStory] =
    useState(false);
  const [randomImageUrl, setRandomImageUrl] = useState(""); // eslint-disable-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingForChapter, setIsLoadingForChapter] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState("");
  const [isEditingFutureId, setIsEditingFutureId] = useState(false);

  const [futureIdData, setFutureIdData] = useState({
    title: "Future Identity",
    description: "Future Identity Discription",
  });

  const [isEditingCurrentID, setIsEditingCurrentID] = useState(false);

  const [currentIdData, setCurrentIdData] = useState({
    title: "Current Identity",
    description: "Current Identity Discription",
  });

  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("future");
  const { user } = useContext(UserContext);

  const location = useLocation();
  const storyId = location.state?.storyId;

  const queryParams = new URLSearchParams(location.search);
  const storyFromURL = queryParams.get("story_id");

  const addFirstResponse = useCallback(
    async (sessionID) => {
      setIsLoadingData("Adding your first step");
      const payload = {
        coachee_response: selectedForStartReflection,
        focus_popup_required: 0,
        record_from_focus_popup: 0,
        selected_focus_choice: 1,
        conversation_summary: "",
        regenerate_with_intention: false,
        focus_options: "",
        alternate_focus_hypothesis: "",
      };
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/users/${user.user_id}/session/${sessionID}/step`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );
        const data = await response.json();
        console.log("First response added:", data);
        if (response.ok) {
          setIsLoadingForChapter(false);
          navigate("/chat");
          console.log(
            "Navigated to chat for reflection on:",
            selectedForStartReflection
          );
        }
      } catch (error) {
        console.error("Error adding first response:", error);
        setIsLoadingForChapter(false);
      }
    },
    [
      user.user_id,
      navigate,
      selectedForStartReflection,
      setIsLoadingData,
      setIsLoadingForChapter,
    ]
  );

  const createSessionForReflection = useCallback(
    async (coach) => {
      if (!selectedStory?.id) {
        console.error("No story selected for reflection");
        setIsLoadingForChapter(false);
        return;
      }

      setIsLoadingData("Your reflection session is being created");
      try {
        const queryParam = `?newChapter=false`;
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/users/${user.user_id}/session/create/${coach.coachName}/${coach.selectedTime}/Sad/${selectedStory.id}${queryParam}`,
          {
            method: "GET",
          }
        );
        console.log(
          "Called create session API for reflection with story_id:",
          selectedStory.id
        );

        if (!res.ok) {
          throw new Error("Failed to create session");
        }

        const createSession = await res.json();
        console.log("Session created for reflection:", createSession);

        // Add first response with the selected reflection topic
        addFirstResponse(createSession.session_id);
      } catch (error) {
        console.error("Error creating reflection session:", error);
        setIsLoadingForChapter(false);
      }
    },
    [user.user_id, addFirstResponse, selectedStory]
  );

  const endAllRunningSessionsForReflection = useCallback(async () => {
    setIsLoadingData("All running conversations are being closed");
    const coach = { coachName: "Eira", selectedTime: 21 };
    try {
      await fetch(
        `${process.env.REACT_APP_BACKEND_API_URL}/users/${user.user_id}/session/end`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Session Ended for reflection");
      createSessionForReflection(coach);
    } catch (error) {
      console.log("The session has ended:", error.message);
    }
  }, [user.user_id, createSessionForReflection]);

  const handleStartReflection = useCallback(() => {
    setIsLoadingForChapter(true);
    endAllRunningSessionsForReflection();
  }, [endAllRunningSessionsForReflection]);

  // NEW: Handle "Let's Address" functionality
  useEffect(() => {
    // if (!selectedForStartReflection) return;
    if (!selectedForStartReflection || !selectedStory) return;
    console.log("Starting reflection for:", selectedForStartReflection);
    handleStartReflection();
  }, [selectedForStartReflection, handleStartReflection, selectedStory]);

  // const handleStartReflection = () => {
  //   setIsLoadingForChapter(true);
  //   endAllRunningSessionsForReflection();
  // };

  // Handle "Untangle a new knot" click with reset logic
  const handleUntangleNewKnot = () => {
    if (selectedStory && needsResetBeforeNewStory) {
      setSelectedStory(null);
      setStoryChapters(null);
      setStoryIdentity("");
      setShowTitlePopup(false);
      setNeedsResetBeforeNewStory(false);
      setIsEditingFutureId(false);
      setIsEditingCurrentID(false);
      setFutureIdData({
        title: "Future Identity",
        description: "Future Identity Discription",
      });
      setCurrentIdData({
        title: "Current Identity",
        description: "Current Identity Discription",
      });
      // Reset barriers and stakes
      setStakeData({ Recoverable: [], Critical: [] });
      setAllBarriers({ internal: [], external: [] });
      setRecentBarriers({ internal: [], external: [] });
      setSelectedForStartReflection(null);
      console.log(
        "Reset to dashboard view - first click after story selection"
      );
      return;
    }

    navigate("/chat", { state: { source: "newStory" } });
    console.log("Navigating to new story chat");
  };

  // NEW: Fetch Stakes for selected story
  const fetchStakes = useCallback(
    async (storyId) => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/stake`
        );

        if (!response.ok) {
          const errorData = await response.json();
          console.error("Failed to fetch stake:", errorData.detail);
          return;
        }

        const result = await response.json();
        console.log("Raw Stake Data:", result);

        const rawStakeList = result?.stake?.stake ?? [];

        const normalized = rawStakeList.flatMap((entry) => {
          if (entry?.stake && entry?.risk_level && entry?.implication) {
            return [
              {
                stake: entry.stake,
                risk_level: entry.risk_level,
                implication: entry.implication,
              },
            ];
          }

          const nested = entry.stakes || entry.stake;
          if (Array.isArray(nested)) {
            return nested.map((item) => ({
              stake: item.stake || item.label || "Unknown",
              risk_level: item.risk_level || "Unknown",
              implication: item.implication || "",
            }));
          }

          return [];
        });

        const recoverable = normalized
          .filter((s) => s.risk_level === "Recoverable")
          .map((s) => `${s.stake}: ${s.implication}`)
          .slice(-3);

        const critical = normalized
          .filter((s) => s.risk_level !== "Recoverable")
          .map((s) => `${s.stake}: ${s.implication}`)
          .slice(-3);

        setStakeData({
          Recoverable: recoverable,
          Critical: critical,
        });
      } catch (err) {
        console.error("Error fetching stake data:", err);
      }
    },
    [user.user_id]
  );

  // NEW: Fetch Barriers for selected story
  const fetchBarriers = useCallback(
    async (storyId) => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/${storyId}/barrier`
        );
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Failed to fetch barriers:", errorData.detail);
          return;
        }

        const data = await response.json();
        console.log("barriers", data);
        const internalGroups = data?.barriers.internal_barrier;
        const externalGroups = data?.barriers.external_barrier;

        const allInternal = internalGroups
          .flatMap((group) => group.internal_barrier || [])
          .filter(
            (b) => b.label && !b.label.startsWith("None, explanation as:")
          );

        const allExternal = externalGroups
          .flatMap((group) => group.external_barrier || [])
          .filter(
            (b) =>
              b.label &&
              b.label !== "None" &&
              !b.label.startsWith("None, explanation as:")
          );

        setAllBarriers({
          internal: allInternal,
          external: allExternal,
        });

        setRecentBarriers({
          internal: allInternal.slice(-3),
          external: allExternal.slice(-3),
        });
      } catch (err) {
        console.error("Error fetching barriers:", err);
      }
    },
    [user.user_id]
  );

  const getStoryDetails = useCallback(
    async (story) => {
      setIsLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/workspace/${user.user_id}/${story.id}/identity`
        );
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Failed to fetch comments:", errorData.detail);
          return;
        }

        const data = await response.json();
        console.log(data);
        setStoryChapters(data.chapters);
        setStoryIdentity(data.identity);

        if (!data.identity.is_title_selected) {
          setShowTitlePopup(true);
        }

        setCurrentIdData({
          title: data.identity.current_identity_title,
          description: data.identity.current_identity,
        });
        setFutureIdData({
          title: data.identity.emerging_identity_title,
          description: data.identity.emerging_identity,
        });
        setSelectedStory(story);
        setNeedsResetBeforeNewStory(true);

        // NEW: Fetch barriers and stakes for the selected story
        await fetchStakes(story.id);
        await fetchBarriers(story.id);

        setIsLoading(false);
      } catch (err) {
        console.error("Error fetching comments:", err);
        setIsLoading(false);
      }
    },
    [user.user_id, fetchStakes, fetchBarriers]
  );

  useEffect(() => {
    if (storyId && userStorys.length > 0) {
      const matched = userStorys.find((s) => s.id === storyId);
      if (matched) {
        setSelectedStory(matched);
        getStoryDetails(matched);
        setStoryChapters("");
        setNeedsResetBeforeNewStory(true);
      }
    }
  }, [storyId, userStorys, getStoryDetails]);

  const isMobile = () => window.innerWidth < 768; // eslint-disable-line no-unused-vars

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.6s ease-out forwards;
        }
      `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  // useEffect(() => {
  //   const fetchUserStory = async () => {
  //     try {
  //       const response = await fetch(
  //         `${process.env.REACT_APP_BACKEND_API_URL}/workspace/${user.user_id}/title`
  //       );
  //       if (!response.ok) {
  //         const errorData = await response.json();
  //         console.error("Failed to fetch comments:", errorData.detail);
  //         return;
  //       }

  //       const data = await response.json();
  //       console.log(data);

  //     // ADD ARRAY CHECK HERE - Handle cases where data might not be an array
  //     if (!Array.isArray(data)) {
  //       console.error("Expected array but got:", typeof data, data);
  //       // If data is an object with a stories property, use that
  //       const storiesArray = data?.stories || data?.data || [];
  //       if (Array.isArray(storiesArray)) {
  //         setUserStorys(storiesArray);
  //       } else {
  //         setUserStorys([]); // Fallback to empty array
  //       }
  //       return;
  //     }

  //       const filteredData = data.filter(
  //         (story) =>
  //           story.selected_title ||
  //           (Array.isArray(story.title) && story.title.length > 0)
  //       );
  //       console.log("this is the filterd data ", filteredData);
  //       setUserStorys(filteredData);

  //       if (storyFromURL) {
  //         const matched = filteredData.find(
  //           (story) => story.id === storyFromURL
  //         );
  //         console.log("this is the matched value", matched);
  //         if (matched) {
  //           setSelectedStory(matched);
  //           getStoryDetails(matched);
  //         }

  //         const newURL = location.pathname;
  //         navigate(newURL, { replace: true });
  //       }
  //     } catch (err) {
  //       console.error("Error fetching comments:", err);
  //       setUserStorys([]);
  //     }
  //   };
  //   fetchUserStory();
  // }, [
  //   user.user_id,
  //   storyFromURL,
  //   getStoryDetails,
  //   location.pathname,
  //   navigate,
  // ]);

  useEffect(() => {
    const fetchUserStory = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/workspace/${user.user_id}/title`
        );
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Failed to fetch comments:", errorData.detail);
          return;
        }

        const data = await response.json();
        console.log(data);

        // ✅ HANDLE API RESPONSE: Check if it's a "no titles found" message or not an array
        if (!Array.isArray(data)) {
          // Check if it's the "no titles found" message from the API
          if (data?.message === "No titles found for this user.") {
            console.log("No stories found for user - displaying empty state");
            setUserStorys([]);
            return;
          }

          // Handle other non-array responses (in case API structure changes)
          console.error("Expected array but got:", typeof data, data);
          const storiesArray = data?.stories || data?.data || [];
          setUserStorys(Array.isArray(storiesArray) ? storiesArray : []);
          return;
        }

        // ✅ DATA IS AN ARRAY - proceed with filtering
        const filteredData = data.filter(
          (story) =>
            story.selected_title ||
            (Array.isArray(story.title) && story.title.length > 0)
        );
        console.log("this is the filterd data ", filteredData);
        setUserStorys(filteredData);

        // ✅ HANDLE storyFromURL ONLY IF WE HAVE STORIES
        if (storyFromURL && filteredData.length > 0) {
          const matched = filteredData.find(
            (story) => story.id === storyFromURL
          );
          console.log("this is the matched value", matched);
          if (matched) {
            setSelectedStory(matched);
            getStoryDetails(matched);
          }

          const newURL = location.pathname;
          navigate(newURL, { replace: true });
        }
      } catch (err) {
        console.error("Error fetching comments:", err);
        // ✅ SET EMPTY ARRAY ON ERROR TO PREVENT CRASHES
        setUserStorys([]);
      }
    };
    fetchUserStory();
  }, [
    user.user_id,
    storyFromURL,
    getStoryDetails,
    location.pathname,
    navigate,
  ]);

  useEffect(() => {
    const fetchUserStats = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_API_URL}/storyDetails/${user.user_id}/stats`
        );
        if (!response.ok) {
          const errorData = await response.json();
          console.error("Failed to fetch stats:", errorData.detail);
          return;
        }

        const data = await response.json();
        console.log("this is the state", data);
        setSessionStats(data);
      } catch (err) {
        console.error("Error fetching stats:", err);
      }
    };
    fetchUserStats();
  }, [user.user_id]);

  // const getStoryDetails = async (story) => {
  //   setIsLoading(true);
  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BACKEND_API_URL}/workspace/${user.user_id}/${story.id}/identity`
  //     );
  //     if (!response.ok) {
  //       const errorData = await response.json();
  //       console.error("Failed to fetch comments:", errorData.detail);
  //       return;
  //     }

  //     const data = await response.json();
  //     console.log(data);
  //     setStoryChapters(data.chapters);
  //     setStoryIdentity(data.identity);

  //     if (!data.identity.is_title_selected) {
  //       setShowTitlePopup(true);
  //     }

  //     setCurrentIdData({
  //       title: data.identity.current_identity_title,
  //       description: data.identity.current_identity,
  //     });
  //     setFutureIdData({
  //       title: data.identity.emerging_identity_title,
  //       description: data.identity.emerging_identity,
  //     });
  //     setSelectedStory(story);
  //     setNeedsResetBeforeNewStory(true);

  //     // NEW: Fetch barriers and stakes for the selected story
  //     await fetchStakes(story.id);
  //     await fetchBarriers(story.id);

  //     setIsLoading(false);
  //   } catch (err) {
  //     console.error("Error fetching comments:", err);
  //     setIsLoading(false);
  //   }
  // };

  const getChapterDisplayTitle = (chapter) => {
    if (
      chapter.selected_title &&
      typeof chapter.selected_title.title === "string"
    ) {
      return chapter.selected_title.title;
    }

    if (
      Array.isArray(chapter.title) &&
      chapter.title.length > 0 &&
      typeof chapter.title[0].title === "string"
    ) {
      return chapter.title[0].title;
    }

    return "Unfinished Chapter";
  };

  // const handleTitleSelection = (chapterId, selectedTitle) => {
  //   console.log(`Selected title for chapter ${chapterId}:`, selectedTitle);
  // };

  const handleNewChapter = (storyId) => {
    setIsLoadingForChapter(true);
    endAllRunningSessions();
  };

  const endAllRunningSessions = async () => {
    setIsLoadingData("All running conversations are being closed");
    const coach = { coachName: "Eira", selectedTime: 21 };
    try {
      await fetch(
        `${process.env.REACT_APP_BACKEND_API_URL}/users/${user.user_id}/session/end`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Session Ended");
      createSession(coach);
    } catch (error) {
      console.log("The session has ended:", error.message);
    }
  };

  const createSession = async (coach) => {
    // const currentMood = "NO mood selecter for this chapter";  // eslint-disable-line no-unused-vars

    if (!selectedStory?.id) {
      console.error("No story selected for new chapter");
      setIsLoadingForChapter(false);
      return;
    }

    setIsLoadingData("Your new chapter is being created");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_API_URL}/users/${user.user_id}/session/create/${coach.coachName}/${coach.selectedTime}/Sad/${selectedStory.id}`,
        {
          method: "GET",
        }
      );
      console.log(
        "Called continue session API with story_id:",
        selectedStory.id
      );

      if (!res.ok) {
        throw new Error("Failed to create session");
      }

      const createSession = await res.json();
      console.log(createSession);

      navigate("/chat");
      console.log(selectedStory.id, "story id is from start new chapter");

      console.log("sessio will be created in a min");
    } catch (error) {
      console.error("Error creating session:", error);
      setIsLoadingForChapter(false);
    }
  };

  const handleChapterClick = (chapter) => {
    console.log(chapter);
    const chapterTitle = getChapterDisplayTitle(chapter);
    console.log(chapterTitle);
    if (chapterTitle === "Unfinished Chapter") {
      continuePreviousConversation(chapter.session_id);
      console.log("chapter is needed to contiue");
    } else {
      navigate("/PastChats", {
        state: {
          source: "showHistory",
          session_id: chapter.session_id,
        },
      });
    }
  };

  const continuePreviousConversation = async (session_id) => {
    try {
      await fetch(
        `${process.env.REACT_APP_BACKEND_API_URL}/users/${user.user_id}/session/end`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("Session Ended");
    } catch (error) {
      console.log("The session has ended:", error.message);
    }
    try {
      // const res = await fetch(
      await fetch(
        `${process.env.REACT_APP_BACKEND_API_URL}/users/Previous_session/${session_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("contenue session");
      navigate("/chat");
    } catch (error) {
      console.log("The session has ended:", error.message);
      navigate("/");
    }
  };

  const handleFutureIdSave = async () => {
    setIsEditingFutureId(false);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_API_URL}/workspace/${user.user_id}/update_future_id`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userid: user.user_id,
            story_id: storyIdentity.id,
            updated_check: "this is a new feild",
            future_identity: futureIdData.description,
            future_identity_title: futureIdData.title,
          }),
        }
      );

      if (!res.ok) throw new Error("Failed to update Future ID");

      const data = await res.json();
      console.log("Future ID updated:", data);
    } catch (error) {
      console.error("Error updating Future ID:", error);
    }
  };

  const handleCurrentIdSave = async () => {
    setIsEditingCurrentID(false);
    console.log(storyIdentity.id);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BACKEND_API_URL}/workspace/${user.user_id}/update_current_id`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userid: user.user_id,
            story_id: storyIdentity.id,
            updated_check: "this is a new feild",
            current_identity: currentIdData.description,
            current_identity_title: currentIdData.title,
          }),
        }
      );

      if (!res.ok) throw new Error("Failed to update Future ID");

      const data = await res.json();
      console.log("Future ID updated:", data);
    } catch (error) {
      console.error("Error updating Future ID:", error);
    }
  };

  const handleTitleSelected = (title) => {
    if (!title || title.trim() === "") return;
    setSelectedStory((prev) => ({
      ...prev,
      selected_title: title,
    }));

    setUserStorys((prevStories) =>
      prevStories.map((story) =>
        story.id === selectedStory.id
          ? { ...story, selected_title: title }
          : story
      )
    );
  };

  const isNoExternalBarrier =
    barrierTab === "External" &&
    (recentBarriers.external.length === 0 ||
      recentBarriers.external[0] === "No external barrier is present");

  return (
    <div className="bg-[#F5F5F5]">
      {/* Title selection popup on top */}
      {showTitlePopup && storyIdentity && (
        <TitleSelectionPopup
          titles={storyIdentity.title || []}
          story_id={storyIdentity.id}
          onClose={(title) => {
            setShowTitlePopup(false);
            handleTitleSelected(title);
          }}
        />
      )}
      <div className="flex flex-col md:flex-row md:h-screen font-gotham bg-[#F5F5F5] container scrollbar-hide mx-auto w-full pb-1">
        {/* Sidebar */}
        <div className="w-full md:w-[20%] h-auto bg-[#F5F5F5] md:overflow-y-auto border-r scrollbar-hide md:scrollbar-default border-gray-300">
          {/* Mobile/Small Screen Version - Compact with Arrow Navigation */}
          <div className="block md:hidden w-full px-2 py-2">
            {/* Stories Horizontal Scroll - Mobile with Arrow Controls */}
            <div className="relative flex items-center">
              {/* Left Arrow Button */}
              <button
                onClick={() => {
                  const container = document.getElementById(
                    "stories-scroll-container"
                  );
                  container.scrollBy({ left: -100, behavior: "smooth" });
                }}
                className="flex-shrink-0 w-7 h-7 bg-white border border-gray-300 rounded-full flex items-center justify-center shadow-sm hover:shadow-md transition-all duration-200 mr-2 z-10"
              >
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 24 24"
                  fill="none"
                  className="text-gray-600"
                >
                  <path
                    d="M15 18L9 12L15 6"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              {/* Compact Stories Container */}
              <div
                id="stories-scroll-container"
                className="flex overflow-x-auto space-x-2 pb-1 scrollbar-hide flex-1"
                style={{
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                {/* New Story Button */}
                <button
                  onClick={handleUntangleNewKnot}
                  className={`flex-shrink-0 w-20 ${
                    !selectedStory ? "border-[#54B0AF] border" : "border"
                  } bg-white rounded-lg py-2 px-2 text-[10px] font-medium text-[#484848] flex flex-col items-center justify-center shadow hover:shadow-md font-gotham`}
                >
                  <span className="w-4 h-4 flex items-center justify-center border border-[#484848] rounded-full text-xs mb-1">
                    ＋
                  </span>
                  <span className="text-center leading-tight">
                    Untangle a new knot
                  </span>
                </button>

                {/* Stories Scroll Items */}
                {userStorys.map((story) => {
                  const isSelected = selectedStory?.id === story.id;

                  return (
                    <div key={story.id} className="flex-shrink-0 w-20">
                      <div
                        onClick={() => {
                          getStoryDetails(story);
                          setStoryChapters("");
                        }}
                        className="cursor-pointer"
                      >
                        <div
                          className={`rounded-lg w-full border px-2 py-1.5 transition-all bg-white flex flex-col items-center ${
                            isSelected
                              ? "border-teal-400 shadow-md"
                              : "border-gray-200 hover:border-gray-300"
                          }`}
                        >
                          <img
                            src={story.image_url || randomImageUrl || storyImg}
                            alt={story.title}
                            className="w-14 h-8 object-contain mb-1"
                          />
                          <span className="text-[9px] font-medium text-[#323232] font-gotham leading-tight text-center line-clamp-1">
                            {(story.selected_title?.length > 8
                              ? story.selected_title.substring(0, 8) + "..."
                              : story.selected_title) ||
                              story.title?.[0]?.title ||
                              "Untitled"}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Right Arrow Button */}
              <button
                onClick={() => {
                  const container = document.getElementById(
                    "stories-scroll-container"
                  );
                  container.scrollBy({ left: 100, behavior: "smooth" });
                }}
                className="flex-shrink-0 w-7 h-7 bg-white border border-gray-300 rounded-full flex items-center justify-center shadow-sm hover:shadow-md transition-all duration-200 ml-2 z-10"
              >
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 24 24"
                  fill="none"
                  className="text-gray-600"
                >
                  <path
                    d="M9 18L15 12L9 6"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>

            {/* Display Only Selected Story */}
            {selectedStory && (
              <div className="flex justify-center items-center w-full">
                <div
                  key={selectedStory.id}
                  className="rounded-2xl transition-all overflow-hidden mt-4 px-16 w-full max-w-[300px]"
                >
                  {/* Expanded Selected Story View */}
                  <div className="flex flex-col items-center cursor-pointer hover:shadow-sm">
                    <div className="rounded-2xl w-full border px-8 py-2 bg-white flex justify-center items-center border-teal-400 mb-2">
                      <img
                        src={
                          selectedStory.image_url || randomImageUrl || storyImg
                        }
                        alt={selectedStory.title}
                        className="w-40 h-24 object-contain mb-2"
                      />
                    </div>
                    <div className="text-left w-full px-2">
                      <h3 className="text-[12px] font-medium text-[#323232] font-gotham leading-tight whitespace-nowrap tracking-tight">
                        {selectedStory.selected_title ||
                          selectedStory.title?.[0]?.title ||
                          "Untitled"}
                      </h3>
                    </div>
                  </div>

                  {/* Chapter Details */}
                  <div className="mt-2 pl-2 rounded-lg">
                    <button
                      onClick={() => handleNewChapter(selectedStory.id)}
                      className="w-full text-xs text-[#54B0AF] bg-gradient-to-br from-white via-[#E3F5F500] to-[#54B0AF25] font-gotham py-2 px-3 rounded-lg flex items-center justify-center font-medium mb-2 my-1 shadow-xl transition-all duration-200 hover:bg-teal-50 hover:shadow-md"
                    >
                      <FaCirclePlus className="w-5 h-5 mr-2 flex items-center justify-center font-medium text-[#54B0AF]" />
                      <span className="text-[#323232]">
                        &nbsp;New&nbsp;Chapter
                      </span>
                    </button>

                    {/* Chapter List */}
                    <div className="space-y-1 max-h-24 border-l-2 pl-1.5 border-gray-300 scrollbar-hide overflow-y-auto overflow-x-hidden ">
                      {storyChapters && storyChapters.length > 0 ? (
                        storyChapters.map((chapter) => (
                          <div
                            key={chapter.id}
                            className="w-full pl-2 text-[10px] bg-white text-[#323232] font-gotham py-1.5 px-2 rounded-md cursor-pointer font-medium transition-colors duration-200"
                            onClick={() => {
                              console.log("Chapter clicked:", chapter);
                            }}
                          >
                            {getChapterDisplayTitle(chapter)}
                          </div>
                        ))
                      ) : (
                        <div className="text-[9px] text-gray-400 font-gotham italic px-2 py-1 text-center">
                          No chapters yet. Create your first chapter!
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Desktop/Large Screen Version */}
          <div className="hidden justify-between md:block px-8 lg:px-10 py-4 space-y-4 md:space-y-6">
            <div className="flex justify-center rounded-[20px]">
              <button
                onClick={handleUntangleNewKnot}
                className={`max-w-[220px] h-full max-h-[100px] w-full ${
                  !selectedStory ? "border-[#54B0AF] border" : "border"
                } bg-white rounded-[20px] py-6 text-md font-medium text-[#484848] flex flex-col items-center justify-center hover:shadow-md font-gotham`}
              >
                <span className="w-8 h-8 flex items-center justify-center border border-[#484848] rounded-full text-xl mb-2">
                  ＋
                </span>
                Untangle a new knot
              </button>
            </div>

            {/* Story List */}
            {userStorys.map((story, index) => {
              const isSelected = selectedStory?.id === story.id;

              return (
                <div
                  key={story.id}
                  className="rounded-[20px] transition-all overflow-hidden mb-4"
                >
                  <div
                    onClick={() => {
                      getStoryDetails(story);
                      setStoryChapters("");
                      console.log(story);
                    }}
                    className="flex flex-col items-center cursor-pointer hover:shadow-sm "
                  >
                    <div
                      className={`max-w-[220px] h-full max-h-[100px] rounded-[20px] w-full border py-2 transition-all overflow-hidden mb-1 bg-white flex justify-center items-center ${
                        isSelected ? "border border-[#54B0AF]" : ""
                      }`}
                    >
                      <img
                        src={story.image_url || randomImageUrl || storyImg}
                        alt={story.title}
                        className="w-40 h-24 object-contain mb-2"
                      />
                    </div>
                    <div className="text-left w-full px-2 leading-4">
                      <span className="text-[12px] font-medium text-[#323232] font-gotham">
                        {story.selected_title ||
                          story.title?.[0]?.title ||
                          "Untitled"}
                      </span>
                    </div>
                  </div>

                  {isSelected && (
                    <div className="px-2 pb-4 mt-1 space-y-2 lg:space-y-4">
                      <div className="border-l border-gray-300 pl-1.5 mr-3">
                        <button
                          onClick={() => handleNewChapter(story.id)}
                          className="w-full text-xs text-[#54B0AF] bg-gradient-to-br from-white via-[#E3F5F500] to-[#54B0AF25] font-gotham py-2 px-3 rounded-lg flex items-center justify-center font-medium mb-2 my-1 shadow-xl transition-all duration-200 hover:bg-teal-50 hover:shadow-md"
                        >
                          <FaCirclePlus className="w-5 h-5 mr-2 flex items-center justify-center font-medium text-[#54B0AF]" />
                          <span className="text-[#323232]">
                            &nbsp;New&nbsp;Chapter
                          </span>
                        </button>

                        {/* Dynamic Chapter List */}
                        {isSelected &&
                          storyChapters &&
                          storyChapters.length > 0 &&
                          storyChapters.map((chapter) => (
                            <div
                              key={chapter.id}
                              className="w-full text-[10px] bg-white text-[#323232] font-gotham py-1.5 px-3 rounded-lg text-left cursor-pointer font-medium mt-2"
                              onClick={() => {
                                console.log("Chapter clicked:", chapter);
                                handleChapterClick(chapter);
                              }}
                            >
                              {getChapterDisplayTitle(chapter)}
                            </div>
                          ))}

                        {/* Show message if no chapters */}
                        {isSelected &&
                          (!storyChapters || storyChapters.length === 0) && (
                            <div className="text-[10px] text-[#323232] font-gotham italic px-3 py-2">
                              No chapters yet. Create your first chapter!
                            </div>
                          )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Main Content */}
        <div className="flex-1 py-4 px-3 md:px-10 overflow-auto overflow-y-auto font-sans scrollbar-hide md:w-[60%]">
          {selectedStory ? (
            <div>
              {isLoading ? (
                <div className="flex justify-center items-center w-full h-screen">
                  <div className="w-20 h-20 border-4 border-gray-300 border-t-[#54B0AF] rounded-full animate-spin"></div>
                </div>
              ) : (
                <div>
                  <div className="flex flex-col lg:flex-row gap-6">
                    {/* Left: Story Card + Identities */}
                    <div className="flex flex-col gap-3 md:gap-6">
                      {/* Card */}
                      <div className="bg-white rounded-2xl px-4 md:px-8 flex flex-col md:flex-row items-center justify-between shadow-sm w-full md:min-h-[280px] max-w-full">
                        {/* Left Text Section */}
                        <div className="flex flex-col items-start justify-between px-4 md:px-0 py-4 md:py-3 md:w-1/3 w-full mb-4 md:mb-0">
                          <h2 className="text-xl lg:text-2xl xl:text-[28px] font-gotham font-bold text-[#323232] leading-snug">
                            {selectedStory.selected_title ||
                              selectedStory.title?.[0]?.title ||
                              "Untitled"}
                          </h2>
                        </div>

                        {/* Image Centered */}
                        <div className="flex justify-center items-center -translate-y-5 sm:translate-y-0 w-full md:w-auto max-w-[280px] md:max-w-[340px]">
                          <img
                            src={
                              selectedStory.image_url ||
                              randomImageUrl ||
                              storyImg
                            }
                            alt="Story Illustration"
                            className="w-full h-auto md:h-72 object-cover"
                          />
                        </div>

                        <div className="w-full md:w-1/3 flex justify-center translate-x-0 sm:translate-x-3 mt-2 mb-2 sm:mb-0 sm:mt-36">
                          <button
                            className="bg-[#54B0AF] hover:bg-[#469a99] transition-colors duration-300 px-6 py-3 lg:px-8 lg:py-3.5 xl:py-3 2xl:py-4 rounded-full text-white text-sm lg:text-base font-bold shadow-md whitespace-nowrap w-full md:w-48 lg:w-52 xl:w-[14rem] 2xl:w-[16rem]"
                            onClick={() => {
                              onSelectStory(storyIdentity.id);
                              navigate(`/workspace/${storyIdentity.id}`);
                            }}
                          >
                            Notice, Then Untangle
                          </button>
                        </div>
                      </div>

                      {/* Identity Tabs - Fixed layout issues */}
                      <div className="sm:px-6 md:px-0 py-6 rounded-2xl">
                        <div className="flex flex-col md:flex-row gap-6 md:gap-8 relative items-stretch w-full max-w-[100%]">
                          {/* === Current Identity === */}
                          <div
                            className={`flex md:flex-col shrink-0 transition-all duration-700 ease-in-out ${
                              activeTab === "current"
                                ? "flex-1 order-1"
                                : "md:w-20 w-full min-h-[80px] md:min-h-[300px] order-1"
                            }`}
                          >
                            <AnimatePresence mode="wait">
                              {activeTab === "current" ? (
                                <motion.div
                                  key="current-expanded"
                                  layout
                                  initial={{ opacity: 0, y: 20 }}
                                  animate={{ opacity: 1, y: 0 }}
                                  exit={{ opacity: 0, y: -20 }}
                                  transition={{
                                    duration: 0.5,
                                    ease: "easeOut",
                                  }}
                                  className="bg-white rounded-2xl shadow-sm flex-1 text-sm leading-relaxed w-full h-full flex flex-col"
                                >
                                  <div className="p-6 lg:p-8 flex-1 relative">
                                    {!isEditingCurrentID && (
                                      <button
                                        onClick={() =>
                                          setIsEditingCurrentID(true)
                                        }
                                        className="absolute right-4 top-4 bg-gray-100 p-2 rounded-full shadow"
                                      >
                                        <PencilLine className="w-5 h-5 text-gray-500 hover:text-gray-700" />
                                      </button>
                                    )}

                                    <div className="flex items-center mb-4">
                                      {isEditingCurrentID ? (
                                        <textarea
                                          value={currentIdData.title}
                                          onChange={(e) =>
                                            setCurrentIdData({
                                              ...currentIdData,
                                              title: e.target.value,
                                            })
                                          }
                                          className="font-bold font-gotham text-lg lg:text-2xl text-[#323232] w-full border-b mb-2 border-[#E0E0E0] focus:border-[#54B0AF] focus:bg-white focus:outline-none"
                                        />
                                      ) : (
                                        <h3 className="font-bold font-gotham text-lg md:text-2xl text-[#323232] w-full">
                                          {currentIdData.title ||
                                            "My Current Identity"}
                                        </h3>
                                      )}
                                    </div>

                                    <motion.div
                                      initial={{ opacity: 0, y: 10 }}
                                      animate={{ opacity: 1, y: 0 }}
                                      exit={{ opacity: 0 }}
                                      transition={{ delay: 0.1 }}
                                      className="space-y-4"
                                    >
                                      {isEditingCurrentID ? (
                                        <>
                                          <textarea
                                            value={
                                              Array.isArray(
                                                currentIdData.description
                                              )
                                                ? currentIdData.description[
                                                    currentIdData.description
                                                      .length - 1
                                                  ] || ""
                                                : currentIdData.description
                                            }
                                            onChange={(e) => {
                                              const updatedValue =
                                                e.target.value;
                                              const oldList = Array.isArray(
                                                currentIdData.description
                                              )
                                                ? [...currentIdData.description]
                                                : [];

                                              if (oldList.length > 0) {
                                                oldList[oldList.length - 1] =
                                                  updatedValue;
                                              } else {
                                                oldList.push(updatedValue);
                                              }

                                              setCurrentIdData({
                                                ...currentIdData,
                                                description: oldList,
                                              });
                                            }}
                                            className="font-gotham font-medium text-[#666666] text-base leading-6 w-full border-b border-[#E0E0E0] focus:border-[#54B0AF] focus:bg-white focus:outline-none"
                                            rows={4}
                                          />
                                          <button
                                            onClick={handleCurrentIdSave}
                                            className="mt-4 px-4 py-2 bg-[#54B0AF] font-gotham font-medium text-lg text-white rounded-2xl"
                                          >
                                            Save
                                          </button>
                                        </>
                                      ) : (
                                        <>
                                          {Array.isArray(
                                            currentIdData.description
                                          ) ? (
                                            [...currentIdData.description]
                                              .slice(-3)
                                              .reverse()
                                              .map((item, idx) => (
                                                <p
                                                  key={idx}
                                                  className="font-gotham font-medium text-[#666666] text-lg leading-6 mb-2"
                                                >
                                                  {item}
                                                </p>
                                              ))
                                          ) : (
                                            <p className="font-gotham font-medium text-[#666666] text-lg leading-6">
                                              loading
                                            </p>
                                          )}
                                        </>
                                      )}
                                    </motion.div>
                                  </div>
                                </motion.div>
                              ) : (
                                <motion.button
                                  key="current-collapsed"
                                  onClick={() => setActiveTab("current")}
                                  whileTap={{ scale: 0.97 }}
                                  className="h-auto w-full min-h-[80px] md:min-h-[300px] md:w-20 bg-white rounded-xl flex items-center justify-center transition-all duration-700 ease-in-out hover:bg-gray-50 py-4 px-6 shadow-xl hover:shadow-md"
                                >
                                  <div className="flex flex-col items-center justify-between gap-2 relative">
                                    <span className="text-[#54B0AF] text-xl absolute top-[8rem] hidden md:block">
                                      <FaChevronCircleRight />
                                    </span>
                                    <span className="origin-center font-gotham text-[#323232] font-bold text-lg lg:text-xl whitespace-nowrap md:-rotate-90">
                                      My Current Identity&nbsp;&nbsp;{" "}
                                      <span className="text-[#54B0AF] absolute top-[0.35rem] text-xl ml-1 md:hidden">
                                        <FaChevronCircleDown />
                                      </span>
                                    </span>
                                  </div>
                                </motion.button>
                              )}
                            </AnimatePresence>
                          </div>

                          {/* === Future Identity === */}
                          <div
                            className={`flex md:flex-col shrink-0 transition-all duration-700 ease-in-out ${
                              activeTab === "future"
                                ? "flex-1 order-2"
                                : "md:w-20 w-full min-h-[80px] md:min-h-[300px] order-2"
                            }`}
                          >
                            <AnimatePresence mode="wait">
                              {activeTab === "future" ? (
                                <motion.div
                                  key="future-expanded"
                                  layout
                                  initial={{ opacity: 0, y: 20 }}
                                  animate={{ opacity: 1, y: 0 }}
                                  exit={{ opacity: 0, y: -20 }}
                                  transition={{
                                    duration: 0.5,
                                    ease: "easeOut",
                                  }}
                                  className="bg-white rounded-2xl shadow-sm flex-1 text-sm leading-relaxed w-full h-full flex flex-col"
                                >
                                  <div className="bg-gradient-to-br from-white via-[#E3F5F500] to-[#54B0AF25] p-6 lg:p-8 rounded-2xl flex-1 relative">
                                    {!isEditingFutureId && (
                                      <button
                                        onClick={() =>
                                          setIsEditingFutureId(true)
                                        }
                                        className="absolute right-4 top-4 bg-gray-100 p-2 rounded-full shadow"
                                      >
                                        <PencilLine className="w-5 h-5 text-gray-500 hover:text-gray-700" />
                                      </button>
                                    )}

                                    <div className="flex items-center mb-4">
                                      {isEditingFutureId ? (
                                        <textarea
                                          value={futureIdData.title}
                                          onChange={(e) =>
                                            setFutureIdData({
                                              ...futureIdData,
                                              title: e.target.value,
                                            })
                                          }
                                          className="font-bold font-gotham text-lg md:text-2xl text-[#54B0AF] w-full border-b border-[#E0E0E0] focus:border-[#54B0AF] focus:bg-white focus:outline-none mb-2"
                                        />
                                      ) : (
                                        <h3 className="font-bold font-gotham text-lg md:text-2xl text-[#54B0AF] w-full">
                                          {futureIdData.title ||
                                            "Future Identity"}
                                          <img
                                            src={star}
                                            alt=""
                                            className="h-8 w-8 ml-1 inline-block"
                                          />
                                        </h3>
                                      )}
                                    </div>

                                    <motion.div
                                      initial={{ opacity: 0, y: 10 }}
                                      animate={{ opacity: 1, y: 0 }}
                                      exit={{ opacity: 0 }}
                                      transition={{ delay: 0.1 }}
                                      className="space-y-4"
                                    >
                                      {isEditingFutureId ? (
                                        <>
                                          <textarea
                                            value={
                                              Array.isArray(
                                                futureIdData.description
                                              )
                                                ? futureIdData.description[
                                                    futureIdData.description
                                                      .length - 1
                                                  ] || ""
                                                : futureIdData.description
                                            }
                                            onChange={(e) => {
                                              const updatedValue =
                                                e.target.value;
                                              const oldList = Array.isArray(
                                                futureIdData.description
                                              )
                                                ? [...futureIdData.description]
                                                : [];

                                              if (oldList.length > 0) {
                                                oldList[oldList.length - 1] =
                                                  updatedValue;
                                              } else {
                                                oldList.push(updatedValue);
                                              }

                                              setFutureIdData({
                                                ...futureIdData,
                                                description: oldList,
                                              });
                                            }}
                                            className="font-gotham font-medium text-[#666666] text-base leading-6 w-full border-b border-[#E0E0E0] focus:border-[#54B0AF] focus:bg-white focus:outline-none"
                                            rows={4}
                                          />
                                          <button
                                            onClick={handleFutureIdSave}
                                            className="mt-4 px-4 py-2 bg-[#54B0AF] font-gotham text-lg font-medium text-white rounded-2xl"
                                          >
                                            Save
                                          </button>
                                        </>
                                      ) : (
                                        <>
                                          {Array.isArray(
                                            futureIdData.description
                                          ) &&
                                            [...futureIdData.description]
                                              .slice(-3)
                                              .reverse()
                                              .map((item, idx) => (
                                                <p
                                                  key={idx}
                                                  className="font-gotham font-medium text-[#666666] text-lg leading-6 mb-2"
                                                >
                                                  {item}
                                                </p>
                                              ))}
                                        </>
                                      )}
                                    </motion.div>
                                  </div>
                                </motion.div>
                              ) : (
                                <motion.button
                                  key="future-collapsed"
                                  onClick={() => setActiveTab("future")}
                                  whileTap={{ scale: 0.97 }}
                                  className="h-auto w-full min-h-[80px] md:min-h-[300px] md:w-20 bg-white rounded-xl flex items-center justify-center bg-gradient-to-r from-white to-[#54B0AF25] py-4 px-6 transition-all duration-700 ease-in-out hover:bg-gradient-to-l hover:from-[#54B0AF10] hover:to-[#54B0AF30] shadow-xl hover:shadow-md"
                                >
                                  <div className="flex flex-col items-center justify-between gap-2 relative">
                                    <span className="text-[#54B0AF] text-xl absolute top-[8rem] hidden md:block">
                                      <FaChevronCircleLeft />
                                    </span>

                                    <span className="text-[#323232] font-bold text-lg lg:text-xl font-gotham whitespace-nowrap md:-rotate-90">
                                      <span className="text-[#54B0AF]">
                                        Future
                                      </span>{" "}
                                      Identity&nbsp;&nbsp;{" "}
                                      <span className="text-[#54B0AF] rotate-180 absolute top-[0.35rem] text-xl ml-1 md:hidden">
                                        <FaChevronCircleDown />
                                      </span>
                                    </span>
                                  </div>
                                </motion.button>
                              )}
                            </AnimatePresence>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* NEW: My Barriers and My Stakes - Replacing "Coming Soon" */}
                  <div className="hidden md:block w-full mt-8 rounded-2xl">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8 font-gotham">
                      {/* My Barriers - Redesigned */}
                      <div className="bg-gradient-to-br from-teal-50 via-white to-teal-50 p-8 rounded-3xl shadow-lg border border-teal-100 flex flex-col min-h-[400px] relative overflow-hidden">
                        {/* Background Pattern */}
                        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-teal-100/30 to-transparent rounded-full -translate-y-8 translate-x-8"></div>

                        <div>
                          {/* Header with Icon */}
                          <div className="flex items-center gap-3 mb-6">
                            <div className="w-12 h-12 bg-gradient-to-br from-[#54B0AF] to-teal-600 rounded-2xl flex items-center justify-center shadow-lg">
                              <svg
                                className="w-6 h-6 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
                                />
                              </svg>
                            </div>
                            <div>
                              <h3 className="text-2xl text-[#323232] font-gotham font-bold">
                                My Barriers
                              </h3>
                              <p className="text-sm text-[#484848] font-medium">
                                Forces causing friction
                              </p>
                            </div>
                          </div>

                          {/* Tab Selector - Improved Design */}
                          <div className="relative mb-6">
                            <div className="flex gap-2 bg-slate-100 rounded-2xl p-1.5">
                              <button
                                onClick={() => setBarrierTab("Internal")}
                                className={`relative px-6 py-3 rounded-xl text-sm font-semibold font-gotham transition-all duration-300 flex-1 ${
                                  barrierTab === "Internal"
                                    ? "bg-white text-teal-600 shadow-md"
                                    : "text-[#323232] hover:text-[#323232]"
                                }`}
                              >
                                <span className="relative z-10">Internal</span>
                                {barrierTab === "Internal" && (
                                  <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl opacity-50"></div>
                                )}
                              </button>
                              <button
                                onClick={() => setBarrierTab("External")}
                                className={`relative px-6 py-3 rounded-xl text-sm font-semibold font-gotham transition-all duration-300 flex-1 ${
                                  barrierTab === "External"
                                    ? "bg-white text-teal-600 shadow-md"
                                    : "text-[#323232] hover:text-[#323232]"
                                }`}
                              >
                                <span className="relative z-10">External</span>
                                {barrierTab === "External" && (
                                  <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl opacity-50"></div>
                                )}
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* Content Area */}
                        <div className="flex-grow">
                          <div className="space-y-3">
                            {barrierTab === "Internal" &&
                            recentBarriers.internal?.length === 0 ? (
                              <div className="flex flex-col items-center justify-center py-8">
                                <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mb-4">
                                  <svg
                                    className="w-8 h-8 text-slate-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={1.5}
                                      d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293L18 15.586a1 1 0 01-.707.293h-2.586a1 1 0 01-.707-.293L12 13.586a1 1 0 00-.707-.293H8.707a1 1 0 01-.707-.293L6.293 11.5A1 1 0 005.586 11H3"
                                    />
                                  </svg>
                                </div>
                                <p className="text-slate-500 text-base font-gotham font-medium text-center">
                                  No internal barriers found
                                </p>
                              </div>
                            ) : barrierTab === "External" &&
                              recentBarriers.external?.length === 0 ? (
                              <div className="flex flex-col items-center justify-center py-8">
                                <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mb-4">
                                  <svg
                                    className="w-8 h-8 text-slate-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={1.5}
                                      d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293L18 15.586a1 1 0 01-.707.293h-2.586a1 1 0 01-.707-.293L12 13.586a1 1 0 00-.707-.293H8.707a1 1 0 01-.707-.293L6.293 11.5A1 1 0 005.586 11H3"
                                    />
                                  </svg>
                                </div>
                                <p className="text-slate-500 text-base font-gotham font-medium text-center">
                                  No external barriers found
                                </p>
                              </div>
                            ) : (
                              recentBarriers[
                                barrierTab === "Internal"
                                  ? "internal"
                                  : "external"
                              ]
                                ?.slice()
                                .reverse()
                                .map((barrier, idx) => {
                                  const isExpanded = activeBarrierIdx === idx;
                                  const isSelected =
                                    selectedForStartReflection ===
                                    barrier.label;

                                  return (
                                    <div
                                      key={idx}
                                      onMouseEnter={() => {
                                        if (!isNoExternalBarrier) {
                                          setActiveBarrierIdx(idx);
                                        }
                                      }}
                                      onMouseLeave={() => {
                                        if (!isNoExternalBarrier) {
                                          setActiveBarrierIdx(null);
                                        }
                                      }}
                                      className={`group relative bg-white/80 backdrop-blur-sm border border-slate-200 rounded-2xl p-4 transition-all duration-300 hover:shadow-lg hover:bg-white ${
                                        !isNoExternalBarrier
                                          ? "cursor-pointer"
                                          : ""
                                      } ${
                                        isSelected
                                          ? "ring-2 ring-blue-500/30 bg-blue-50/50"
                                          : ""
                                      }`}
                                    >
                                      <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-3">
                                          {/* <div className="w-2 h-2 bg-[#54B0AF] rounded-full"></div> */}
                                          <span className="text-slate-800 font-medium text-base">
                                            {barrier.label}
                                          </span>
                                        </div>

                                        {!isNoExternalBarrier && (
                                          <button
                                            onClick={() => {
                                              if (!selectedStory) {
                                                console.error(
                                                  "No story selected"
                                                );
                                                return;
                                              }

                                              console.log(
                                                "Clicked barrier label:",
                                                barrier.label
                                              );
                                              setSelectedForStartReflection(
                                                barrier.label
                                              );
                                            }}
                                            className={`flex items-center gap-2 px-4 py-2 bg-[#54B0AF] hover:bg-teal-600 text-white rounded-xl text-sm font-medium transition-all duration-300 ${
                                              isSelected
                                                ? "opacity-100 scale-100"
                                                : "opacity-0 group-hover:opacity-100 scale-95 group-hover:scale-100"
                                            }`}
                                          >
                                            <span>Address</span>
                                            <NotebookPen className="w-4 h-4" />
                                          </button>
                                        )}
                                      </div>

                                      <AnimatePresence initial={false}>
                                        {isExpanded && barrier?.explanation && (
                                          <motion.div
                                            key="explanation"
                                            initial={{ opacity: 0, height: 0 }}
                                            animate={{
                                              opacity: 1,
                                              height: "auto",
                                            }}
                                            exit={{ opacity: 0, height: 0 }}
                                            transition={{ duration: 0.3 }}
                                            className="overflow-hidden mt-3 pt-3 border-t border-slate-100"
                                          >
                                            <p className="text-slate-600 text-sm leading-relaxed">
                                              {barrier.explanation}
                                            </p>
                                          </motion.div>
                                        )}
                                      </AnimatePresence>
                                    </div>
                                  );
                                })
                            )}
                          </div>
                        </div>

                        {/* Footer */}
                        <div className="flex items-center justify-between mt-8 pt-6 border-t border-slate-100">
                          <button className="flex items-center gap-2 text-[#54B0AF] hover:text-teal-600 font-medium transition-colors">
                            <span className="underline">View all barriers</span>
                            <FiArrowRight className="w-4 h-4" />
                          </button>

                          <div className="w-12 h-12 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full flex items-center justify-center">
                            <img src={emoji1} alt="" className="w-8 h-8" />
                          </div>
                        </div>
                      </div>

                      {/* My Stake - Redesigned */}
                      <div className="bg-gradient-to-br from-teal-50 via-white to-teal-50 p-8 rounded-3xl shadow-lg border border-teal-100 flex flex-col min-h-[400px] relative overflow-hidden">
                        {/* Background Pattern */}
                        <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-teal-100/30 to-transparent rounded-full -translate-y-8 translate-x-8"></div>

                        <div>
                          {/* Header with Icon and Alert Indicator */}
                          <div className="flex items-center justify-between mb-6">
                            <div className="flex items-center gap-3">
                              <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center shadow-lg">
                                <svg
                                  className="w-6 h-6 text-white"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
                                  />
                                </svg>
                              </div>
                              <div>
                                <h3 className="text-2xl text-[#323232] font-gotham font-bold">
                                  My Stake
                                </h3>
                                <p className="text-sm text-[#484848] font-medium">
                                  Potential outcomes if delayed
                                </p>
                              </div>
                            </div>

                            <div className="relative">
                              <div className="w-4 h-4 bg-teal-500 rounded-full animate-pulse"></div>
                              <div className="absolute inset-0 w-4 h-4 bg-teal-500 rounded-full animate-ping opacity-75"></div>
                            </div>
                          </div>

                          {/* Tab Selector - Improved Design */}
                          <div className="relative mb-6">
                            <div className="flex gap-2 bg-teal-100 rounded-2xl p-1.5">
                              {["Recoverable", "Critical"].map((key) => (
                                <button
                                  key={key}
                                  onClick={() => setStakeTab(key)}
                                  className={`relative px-6 py-3 rounded-xl text-sm font-semibold font-gotham transition-all duration-300 flex-1 ${
                                    stakeTab === key
                                      ? "bg-white text-teal-600 shadow-md"
                                      : "text-[#323232] hover:text-[#484848]"
                                  }`}
                                >
                                  <span className="relative z-10 flex items-center justify-center gap-2">
                                    {key}
                                    {key === "Critical" && (
                                      <div className="w-0 h-0 bg-[#54B0AF] rounded-full"></div>
                                    )}
                                  </span>
                                  {stakeTab === key && (
                                    <div
                                      className={`absolute inset-0 ${
                                        key === "Critical"
                                          ? "bg-gradient-to-r from-teal-50 to-teal-100"
                                          : "bg-gradient-to-r from-teal-50 to-teal-100"
                                      } rounded-xl opacity-50`}
                                    ></div>
                                  )}
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>

                        {/* Content Area */}
                        <div className="flex-grow">
                          <div className="space-y-3">
                            {stakeData[stakeTab]?.length > 0 ? (
                              stakeData[stakeTab]?.map((point, idx) => {
                                const [stakeName, implication] =
                                  point.split(": ");
                                const isExpanded = activeStakeIdx === idx;
                                const isSelected =
                                  selectedForStartReflection === implication;

                                return (
                                  <div
                                    key={idx}
                                    onMouseEnter={() => setActiveStakeIdx(idx)}
                                    onMouseLeave={() => setActiveStakeIdx(null)}
                                    className={`group relative bg-white/80 backdrop-blur-sm border rounded-2xl p-4 transition-all duration-300 hover:shadow-lg hover:bg-white cursor-pointer ${
                                      stakeTab === "Critical"
                                        ? "border-teal-200 hover:border-teal-300"
                                        : "border-teal-200 hover:border-teal-300"
                                    } ${
                                      isSelected
                                        ? "ring-2 ring-teal-500/30 bg-teal-50/50"
                                        : ""
                                    }`}
                                  >
                                    <div className="flex items-center justify-between">
                                      <div className="flex items-center gap-3">
                                        <div
                                          className={`w-2 h-2 rounded-full ${
                                            stakeTab === "Critical"
                                              ? "bg-teal-500"
                                              : "bg-teal-500"
                                          }`}
                                        ></div>
                                        <span className="text-[#323232] font-medium text-base">
                                          {stakeName}
                                        </span>
                                      </div>

                                      <button
                                        onClick={() => {
                                          if (!selectedStory) {
                                            console.error("No story selected");
                                            return;
                                          }
                                          console.log(
                                            "Clicked stake implication:",
                                            implication
                                          );
                                          setSelectedForStartReflection(
                                            implication
                                          );
                                        }}
                                        className={`flex items-center gap-2 px-4 py-2 bg-[#54B0AF] hover:bg-teal-600 text-white rounded-xl text-sm font-medium transition-all duration-300 ${
                                          isSelected
                                            ? "opacity-100 scale-100"
                                            : "opacity-0 group-hover:opacity-100 scale-95 group-hover:scale-100"
                                        }`}
                                      >
                                        <span>Address</span>
                                        <NotebookPen className="w-4 h-4" />
                                      </button>
                                    </div>

                                    <AnimatePresence initial={false}>
                                      {isExpanded && implication && (
                                        <motion.div
                                          key="implication"
                                          initial={{ opacity: 0, height: 0 }}
                                          animate={{
                                            opacity: 1,
                                            height: "auto",
                                          }}
                                          exit={{ opacity: 0, height: 0 }}
                                          transition={{ duration: 0.3 }}
                                          className="overflow-hidden mt-3 pt-3 border-t border-slate-100"
                                        >
                                          <p className="text-slate-600 text-sm leading-relaxed">
                                            {implication}
                                          </p>
                                        </motion.div>
                                      )}
                                    </AnimatePresence>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="flex flex-col items-center justify-center py-8">
                                <div className="w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mb-4">
                                  <svg
                                    className="w-8 h-8 text-slate-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={1.5}
                                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                  </svg>
                                </div>
                                <p className="text-slate-500 text-base font-gotham font-medium text-center">
                                  No {stakeTab.toLowerCase()} stakes found
                                </p>
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Footer */}
                        <div className="flex items-center justify-between mt-8 pt-6 border-t border-slate-100">
                          <button className="flex items-center gap-2 text-[#54B0AF] hover:text-teal-600 font-medium transition-colors">
                            <span className="underline">View all stakes</span>
                            <FiArrowRight className="w-4 h-4" />
                          </button>

                          <div className="w-12 h-12 bg-gradient-to-br from-red-100 to-red-200 rounded-full flex items-center justify-center">
                            <img src={emoji2} alt="" className="w-8 h-8" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* COMMENTED OUT: Original Coming Soon Section */}
                  {/* <div className="hidden md:block w-full mt-8 rounded-2xl bg-white">
                    <div className="relative bg-white rounded-2xl shadow-sm p-6 sm:p-8 w-full max-w-3xl mx-auto">
                      <div className="absolute top-4 right-4 flex items-center gap-1">
                        <span className="text-sm sm:text-base text-[#54B0AF] font-semibold">
                          Coming Soon
                        </span>
                        <span className="h-2 w-2 rounded-full bg-[#54B0AF] inline-block"></span>
                      </div>
                      <div className="flex flex-col items-center justify-center text-center space-y-4">
                        <img
                          src={emptyBoxes}
                          alt="Coming Soon Box"
                          className="h-20 w-20 sm:h-24 sm:w-24 md:h-48 md:w-60 object-contain"
                        />
                        <h3 className="text-lg sm:text-2xl font-bold font-gotham text-[#323232]">
                          My Space
                        </h3>
                        <p className="text-sm sm:text-base font-gotham font-medium text-[#666666] max-w-xl">
                          Carefully curated content — books, blogs, videos, and
                          more — designed to guide, provoke, or simply sit with
                          you in the right moment.
                        </p>
                      </div>
                    </div>
                  </div> */}
                </div>
              )}
            </div>
          ) : (
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex flex-col items-center justify-center h-auto py-6 sm:py-0 sm:min-h-screen w-full text-center bg-white">
                <img
                  src={boxes}
                  alt="Start a New Story"
                  className="w-40 sm:w-48 md:w-56 lg:w-64 mb-6"
                />

                <h2 className="text-xl sm:text-[22px] lg:text-2xl font-semibold text-[#323232] font-gotham mb-4 flex gap-1.5">
                  <span>
                    <img src={star} alt="" className="w-7 h-7 rotate-180" />
                  </span>{" "}
                  Untangle Your Knot{" "}
                  <span>
                    <img src={star} alt="" className="w-7 h-7" />
                  </span>
                </h2>

                <p className="text[#666666] font-medium text-sm sm:text-base font-gotham max-w-md mb-6 px-2">
                  Whether it's a tight feeling, a looping thought, or something
                  you can't quite name — just notice the knot. Reflection with
                  your clarity panda is all it takes to begin untangling.
                </p>

                <button
                  onClick={handleUntangleNewKnot}
                  className="bg-[#54B0AF] hover:bg-teal-600 text-white px-6 py-2 font-gotham font-bold rounded-full transition-all"
                >
                  Untangle Your Knot
                </button>
              </div>

              <div className=" md:w-[40%]  space-y-4 lg:space-y-5 text-sm px-2">
                <div className="bg-white rounded-2xl p-4 w-full text-sm lg:text-base font-gotham font-medium text-[#666666] shadow-sm">
                  <div className="flex flex-col space-y-1 p-3 divide-y divide-gray-300">
                    <div className="pb-3 text-[#323232] font-medium font-gotham text-base">
                      <span className="font-medium text-[#666666] text-xl">
                        {sessionStats?.day_streak || 0}
                      </span>{" "}
                      {(sessionStats?.day_streak || 0) <= 1 ? "Day" : "Days"}{" "}
                      Streak
                    </div>
                    <div className="py-3 text-[#323232] font-medium font-gotham text-base">
                      <span className="font-bold text-[#666666] text-xl">
                        {sessionStats?.total_conversations || 0}
                      </span>{" "}
                      {(sessionStats?.total_conversations || 0) <= 1
                        ? "Chapter"
                        : "Chapters"}
                    </div>
                    <div className="pt-3 text-[#323232] font-medium font-gotham text-base">
                      <span className="font-bold text-[#666666] text-xl">
                        {userStorys?.length || 0}
                      </span>{" "}
                      {(userStorys?.length || 0) <= 1 ? "Knot" : "Knots"}
                    </div>
                  </div>
                </div>

                <DumpBooth userId={user.user_id} />
              </div>
            </div>
          )}
        </div>

        {/* Right: Sidebar Summary */}
        {selectedStory ? (
          <div className=" md:w-[20%] lg:w-72 space-y-4 lg:space-y-5 text-sm px-2 pr-6 py-4 md:h-screen overflow-y-auto scrollbar-hide">
            <div className="bg-white rounded-2xl p-4 w-full text-sm lg:text-base font-gotham font-medium text-[#666666] shadow-sm">
              <div className="flex flex-col space-y-1 p-3 divide-y divide-gray-300">
                <div className="pb-3">
                  <span className="font-medium text-[#323232] text-base">
                    {sessionStats?.day_streak || 0}
                  </span>{" "}
                  {(sessionStats?.day_streak || 0) <= 1 ? "Day" : "Days"} Streak
                </div>
                <div className="py-3">
                  <span className="font-bold text-[#323232] text-base">
                    {sessionStats?.total_conversations || 0}
                  </span>{" "}
                  {(sessionStats?.total_conversations || 0) <= 1
                    ? "Chapter"
                    : "Chapters"}
                </div>
                <div className="pt-3">
                  <span className="font-bold text-[#323232] text-base">
                    {userStorys?.length || 0}
                  </span>{" "}
                  {(userStorys?.length || 0) <= 1 ? "Knot" : "Knots"}
                </div>
              </div>
            </div>

            <DumpBooth userId={user.user_id} />
          </div>
        ) : (
          <></>
        )}

        {isLoadingForChapter && (
          <div className="fixed inset-0 z-50 bg-white/60 backdrop-blur-sm flex items-center justify-center pointer-events-auto">
            <div className="flex flex-col items-center justify-center space-y-4">
              <div className="w-16 h-16 border-4 border-gray-300 border-t-[#54B0AF] rounded-full animate-spin"></div>
              <span className="text-gray-400 italic text-sm">
                {isLoadingData}
              </span>
            </div>
          </div>
        )}

        {/* Mobile version of My Barriers and My Stakes */}
        {/* Enhanced Mobile version of My Barriers and My Stakes */}
        {selectedStory && (
          <div className="px-3 pr-6 md:px-0 md:hidden">
            <div className="w-full my-2 rounded-2xl">
              <div className="grid grid-cols-1 gap-6 mb-8 font-gotham">
                {/* My Barriers - Enhanced Mobile */}
                <div className="bg-gradient-to-br from-teal-50 via-white to-teal-50 p-6 rounded-3xl shadow-lg border border-teal-100 flex flex-col min-h-[320px] relative overflow-hidden">
                  {/* Background Pattern */}
                  <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-teal-100/30 to-transparent rounded-full -translate-y-6 translate-x-6"></div>

                  <div>
                    {/* Header with Icon */}
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 bg-gradient-to-br from-[#54B0AF] to-teal-600 rounded-2xl flex items-center justify-center shadow-lg">
                        <svg
                          className="w-5 h-5 text-white"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
                          />
                        </svg>
                      </div>
                      <div>
                        <h3 className="text-xl text-[#323232] font-gotham font-bold">
                          My Barriers
                        </h3>
                        <p className="text-sm text-[#484848] font-medium">
                          Forces causing friction
                        </p>
                      </div>
                    </div>

                    {/* Tab Selector - Enhanced Design */}
                    <div className="relative mb-4">
                      <div className="flex gap-1.5 bg-slate-100 rounded-2xl p-1">
                        <button
                          onClick={() => setBarrierTab("Internal")}
                          className={`relative px-4 py-2.5 rounded-xl text-sm font-semibold font-gotham transition-all duration-300 flex-1 ${
                            barrierTab === "Internal"
                              ? "bg-white text-teal-600 shadow-md"
                              : "text-[#323232] hover:text-[#323232]"
                          }`}
                        >
                          <span className="relative z-10">Internal</span>
                          {barrierTab === "Internal" && (
                            <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl opacity-50"></div>
                          )}
                        </button>
                        <button
                          onClick={() => setBarrierTab("External")}
                          className={`relative px-4 py-2.5 rounded-xl text-sm font-semibold font-gotham transition-all duration-300 flex-1 ${
                            barrierTab === "External"
                              ? "bg-white text-teal-600 shadow-md"
                              : "text-[#323232] hover:text-[#323232]"
                          }`}
                        >
                          <span className="relative z-10">External</span>
                          {barrierTab === "External" && (
                            <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl opacity-50"></div>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Content Area */}
                  <div className="flex-grow">
                    <div className="space-y-3">
                      {barrierTab === "Internal" &&
                      recentBarriers.internal?.length === 0 ? (
                        <div className="flex flex-col items-center justify-center py-6">
                          <div className="w-14 h-14 bg-slate-100 rounded-full flex items-center justify-center mb-3">
                            <svg
                              className="w-7 h-7 text-slate-400"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={1.5}
                                d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293L18 15.586a1 1 0 01-.707.293h-2.586a1 1 0 01-.707-.293L12 13.586a1 1 0 00-.707-.293H8.707a1 1 0 01-.707-.293L6.293 11.5A1 1 0 005.586 11H3"
                              />
                            </svg>
                          </div>
                          <p className="text-slate-500 text-sm font-gotham font-medium text-center">
                            No internal barriers found
                          </p>
                        </div>
                      ) : barrierTab === "External" &&
                        recentBarriers.external?.length === 0 ? (
                        <div className="flex flex-col items-center justify-center py-6">
                          <div className="w-14 h-14 bg-slate-100 rounded-full flex items-center justify-center mb-3">
                            <svg
                              className="w-7 h-7 text-slate-400"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={1.5}
                                d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293L18 15.586a1 1 0 01-.707.293h-2.586a1 1 0 01-.707-.293L12 13.586a1 1 0 00-.707-.293H8.707a1 1 0 01-.707-.293L6.293 11.5A1 1 0 005.586 11H3"
                              />
                            </svg>
                          </div>
                          <p className="text-slate-500 text-sm font-gotham font-medium text-center">
                            No external barriers found
                          </p>
                        </div>
                      ) : (
                        recentBarriers[
                          barrierTab === "Internal" ? "internal" : "external"
                        ]
                          ?.slice()
                          .reverse()
                          .slice(0, 3)
                          .map((barrier, idx) => {
                            const isSelected =
                              selectedForStartReflection === barrier.label;

                            return (
                              <div
                                key={idx}
                                onClick={() => {
                                  console.log(
                                    "Mobile barrier clicked:",
                                    barrier.label
                                  );
                                  setSelectedForStartReflection(barrier.label);
                                }}
                                className={`group relative bg-white/80 backdrop-blur-sm border border-slate-200 rounded-2xl p-3 transition-all duration-300 hover:shadow-lg hover:bg-white cursor-pointer ${
                                  isSelected
                                    ? "ring-2 ring-blue-500/30 bg-blue-50/50"
                                    : ""
                                }`}
                              >
                                <div className="flex items-center justify-between">
                                  <div className="flex items-center gap-3">
                                    <div className="w-2 h-2 bg-[#54B0AF] rounded-full"></div>
                                    <span className="text-slate-800 font-medium text-sm">
                                      {barrier.label}
                                    </span>
                                  </div>

                                  <button
                                    className={`flex items-center gap-1.5 px-3 py-1.5 bg-[#54B0AF] hover:bg-teal-600 text-white rounded-lg text-xs font-medium transition-all duration-300 ${
                                      isSelected
                                        ? "opacity-100 scale-100"
                                        : "opacity-0 group-hover:opacity-100 scale-95 group-hover:scale-100"
                                    }`}
                                  >
                                    <span>Address</span>
                                    <NotebookPen className="w-3 h-3" />
                                  </button>
                                </div>
                              </div>
                            );
                          })
                      )}
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="flex items-center justify-between mt-6 pt-4 border-t border-slate-100">
                    <button className="flex items-center gap-2 text-[#54B0AF] hover:text-teal-600 font-medium transition-colors text-sm">
                      <span className="underline">View all barriers</span>
                      <FiArrowRight className="w-3 h-3" />
                    </button>

                    <div className="w-10 h-10 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full flex items-center justify-center">
                      <img src={emoji1} alt="" className="w-6 h-6" />
                    </div>
                  </div>
                </div>

                {/* My Stake - Enhanced Mobile */}
                <div className="bg-gradient-to-br from-teal-50 via-white to-teal-50 p-6 rounded-3xl shadow-lg border border-teal-100 flex flex-col min-h-[320px] relative overflow-hidden">
                  {/* Background Pattern */}
                  <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-br from-teal-100/30 to-transparent rounded-full -translate-y-6 translate-x-6"></div>

                  <div>
                    {/* Header with Icon and Alert Indicator */}
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl flex items-center justify-center shadow-lg">
                          <svg
                            className="w-5 h-5 text-white"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
                            />
                          </svg>
                        </div>
                        <div>
                          <h3 className="text-xl text-[#323232] font-gotham font-bold">
                            My Stake
                          </h3>
                          <p className="text-sm text-[#484848] font-medium">
                            Potential outcomes if delayed
                          </p>
                        </div>
                      </div>

                      <div className="relative">
                        <div className="w-3 h-3 bg-teal-500 rounded-full animate-pulse"></div>
                        <div className="absolute inset-0 w-3 h-3 bg-teal-500 rounded-full animate-ping opacity-75"></div>
                      </div>
                    </div>

                    {/* Tab Selector - Enhanced Design */}
                    <div className="relative mb-4">
                      <div className="flex gap-1.5 bg-teal-100 rounded-2xl p-1">
                        {["Recoverable", "Critical"].map((key) => (
                          <button
                            key={key}
                            onClick={() => setStakeTab(key)}
                            className={`relative px-4 py-2.5 rounded-xl text-sm font-semibold font-gotham transition-all duration-300 flex-1 ${
                              stakeTab === key
                                ? "bg-white text-teal-600 shadow-md"
                                : "text-[#323232] hover:text-[#484848]"
                            }`}
                          >
                            <span className="relative z-10 flex items-center justify-center gap-2">
                              {key}
                              {key === "Critical" && (
                                <div className="w-0 h-0 bg-[#54B0AF] rounded-full"></div>
                              )}
                            </span>
                            {stakeTab === key && (
                              <div
                                className={`absolute inset-0 ${
                                  key === "Critical"
                                    ? "bg-gradient-to-r from-teal-50 to-teal-100"
                                    : "bg-gradient-to-r from-teal-50 to-teal-100"
                                } rounded-xl opacity-50`}
                              ></div>
                            )}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Content Area */}
                  <div className="flex-grow">
                    <div className="space-y-3">
                      {stakeData[stakeTab]?.length > 0 ? (
                        stakeData[stakeTab]?.slice(0, 3).map((point, idx) => {
                          const [stakeName, implication] = point.split(": ");
                          const isSelected =
                            selectedForStartReflection === implication;

                          return (
                            <div
                              key={idx}
                              onClick={() => {
                                console.log(
                                  "Mobile stake clicked:",
                                  implication
                                );
                                setSelectedForStartReflection(implication);
                              }}
                              className={`group relative bg-white/80 backdrop-blur-sm border rounded-2xl p-3 transition-all duration-300 hover:shadow-lg hover:bg-white cursor-pointer ${
                                stakeTab === "Critical"
                                  ? "border-teal-200 hover:border-teal-300"
                                  : "border-teal-200 hover:border-teal-300"
                              } ${
                                isSelected
                                  ? "ring-2 ring-teal-500/30 bg-teal-50/50"
                                  : ""
                              }`}
                            >
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                  <div
                                    className={`w-2 h-2 rounded-full ${
                                      stakeTab === "Critical"
                                        ? "bg-teal-500"
                                        : "bg-teal-500"
                                    }`}
                                  ></div>
                                  <span className="text-[#323232] font-medium text-sm">
                                    {stakeName}
                                  </span>
                                </div>

                                <button
                                  className={`flex items-center gap-1.5 px-3 py-1.5 bg-[#54B0AF] hover:bg-teal-600 text-white rounded-lg text-xs font-medium transition-all duration-300 ${
                                    isSelected
                                      ? "opacity-100 scale-100"
                                      : "opacity-0 group-hover:opacity-100 scale-95 group-hover:scale-100"
                                  }`}
                                >
                                  <span>Address</span>
                                  <NotebookPen className="w-3 h-3" />
                                </button>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="flex flex-col items-center justify-center py-6">
                          <div className="w-14 h-14 bg-slate-100 rounded-full flex items-center justify-center mb-3">
                            <svg
                              className="w-7 h-7 text-slate-400"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={1.5}
                                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                              />
                            </svg>
                          </div>
                          <p className="text-slate-500 text-sm font-gotham font-medium text-center">
                            No {stakeTab.toLowerCase()} stakes found
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="flex items-center justify-between mt-6 pt-4 border-t border-slate-100">
                    <button className="flex items-center gap-2 text-[#54B0AF] hover:text-teal-600 font-medium transition-colors text-sm">
                      <span className="underline">View all stakes</span>
                      <FiArrowRight className="w-3 h-3" />
                    </button>

                    <div className="w-10 h-10 bg-gradient-to-br from-red-100 to-red-200 rounded-full flex items-center justify-center">
                      <img src={emoji2} alt="" className="w-6 h-6" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;